import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const HOME_JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://retaillemon.com/#organization",
    name: "Retail Lemon",
    url: "https://retaillemon.com/",
    logo: "https://retaillemon.com/icon-512.png",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://retaillemon.com/#website",
    name: "Retail Lemon",
    url: "https://retaillemon.com/",
    publisher: { "@id": "https://retaillemon.com/#organization" },
  },
];

export const Route = createFileRoute("/editorial")({
  head: () => ({
    ...publicToolHead("home", "es"),
    meta: [{ title: "Home Editorial | Retail Lemon" }, { name: "robots", content: "noindex, follow" }],
    links: [{ rel: "canonical", href: "https://www.retaillemon.com/" }],
    scripts: HOME_JSON_LD.map((entry) => ({
      type: "application/ld+json",
      children: JSON.stringify(entry),
    })),
  }),
  component: HomeRoute,
  errorComponent: () => <Index />,
  notFoundComponent: () => <Index />,
});

function HomeRoute() {
  return <Index />;
}
